import * as React from "react";
import styled from "@mui/material/styles/styled";
import { Theme } from "@mui/material";
import Card from "@mui/material/Card";
import { URGENCY_DATA } from "fe-web-components/data/urgencyData";
import { Feature } from "fe-common/graphql";
import { Urgency } from "shared";
import clsx from "clsx";
import { MultiLanguageIconContainer } from "../rtl/rtlStyles";

type PatientColorMap = string;
//region [[ Styles ]]

const NavigationRecommendationIndicatorView = styled(Card)(({ theme }) => ({
  borderRadius: "8px",
  boxShadow: "none",
  border: "none",
  margin: 0,
}));

const NavigationRecommendationIcon = styled(MultiLanguageIconContainer)({});

const NavigationRecommendationTitle = styled("div")(
  ({
    theme,
    color,
    backgroundColor,
  }: {
    theme?: Theme;
    color: PatientColorMap;
    backgroundColor: PatientColorMap;
  }) => ({
    fontSize: "17px",
    color: color,
    borderBottom: "1px solid " + color,
    backgroundColor: backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: 700,
    padding: "13px",
  }),
);

const LeftArea = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
});

const RightArea = styled(LeftArea)({});

const ResultTextBottom = styled("div")(
  ({ theme, bgcolor }: { theme?: Theme; bgcolor: PatientColorMap }) => ({
    fontWeight: 500,
    fontSize: "14px",
    color: "#243443",
    padding: "15px",
    backgroundColor: bgcolor,
    whiteSpace: "break-spaces",
    lineHeight: "22px",
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NavigationRecommendationProps {
  className?: string;
  feature: Feature;
  children?: React.ReactNode;
}

//endregion [[ Props ]]
//endregion [[ Functions ]]

export const NavigationRecommendationIndicator = ({
  feature,
  ...props
}: NavigationRecommendationProps) => {
  const units = feature.range.low || 1;

  const urgencyDataByRange = Object.values(URGENCY_DATA).find(
    (data) => data.selectorRange[0] <= units && units <= data.selectorRange[1],
  );

  const urgencyData = urgencyDataByRange || URGENCY_DATA[Urgency.NOT_URGENT];

  return (
    <NavigationRecommendationIndicatorView
      className={clsx("urgency-indicator-view", props.className)}
    >
      <NavigationRecommendationTitle
        color={urgencyData.color as any}
        backgroundColor={urgencyData.lightColor as any}
      >
        <LeftArea>
          <NavigationRecommendationIcon>
            {urgencyData.icon}
          </NavigationRecommendationIcon>
          {<span>{feature.shortname}</span>}
        </LeftArea>
        <RightArea>{props.children}</RightArea>
      </NavigationRecommendationTitle>
      <ResultTextBottom bgcolor={urgencyData.lightColor as any}>
        {feature.patientDescription}
      </ResultTextBottom>
    </NavigationRecommendationIndicatorView>
  );
};
